/* Explainer video (snippets/cz-explainer-video.liquid): poster first, nothing loads until the play button is pressed;
   then it plays with sound and native controls. Only one explainer plays at a time. */
(function () {
  if (window.__czxInit) return;
  window.__czxInit = true;
  function start(frame) {
    var v = frame.querySelector('video'); if (!v) return;
    document.querySelectorAll('[data-czx].is-playing video').forEach(function (o) { if (o !== v) o.pause(); });
    frame.classList.add('is-playing');
    v.preload = 'auto'; v.muted = false; v.controls = true;
    var pr = v.play();
    if (pr && pr.catch) pr.catch(function () { /* playback refused: controls stay visible for a manual start */ });
    v.focus({ preventScroll: true });
  }
  function init() {
    document.querySelectorAll('[data-czx]').forEach(function (frame) {
      if (frame.__czx) return; frame.__czx = true;
      var btn = frame.querySelector('[data-czx-play]');
      if (btn) btn.addEventListener('click', function () { start(frame); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
